import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

import { RewardsStyleVariant } from './reward-categories/types';

export const BackgroundWrapper = styled.div`
  background-color: ${p => p.theme.token('background-active')};
  padding-left: ${primitive.$spacing4};
  padding-right: ${primitive.$spacing4};
`;

export const Background = styled.div`
  background: linear-gradient(
    ${p => p.theme.token('background-active')} 0 140px,
    ${p => p.theme.token('background-pattern')} 140px 100%
  );
`;

export const SectionDescription = styled.div`
  color: ${p => p.theme.token('text-reversed')};
  text-align: center;
  margin: ${primitive.$spacing4} 0;

  ${Styles.mobileTiny`
    font-size: 0.875rem;
  `}
`;

export const SectionHeader = styled.h2<{ variant?: RewardsStyleVariant }>`
  margin: 0;
  padding-top: ${primitive.$spacing4};
  text-align: center;
  font: ${brandFont.headerTwo};
  color: ${({ variant = RewardsStyleVariant.Primary, theme }) =>
    variant === RewardsStyleVariant.Primary
      ? theme.token('text-reversed')
      : theme.token('text-default')};
`;

export const SectionHeaderWrapper = styled.div`
  ${Styles.desktop`
    margin-bottom: ${primitive.$spacing10};
  `}
`;

export const TableContainer = styled.div`
  margin: ${primitive.$spacing4} auto;
`;

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: ${p => p.theme.token('background-active')};

  button {
    font-weight: bold;
  }
`;

export const TabInner = styled.div`
  display: flex;
  width: 400px;
`;

export const TabContentContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  padding-bottom: ${primitive.$spacing8};
  max-width: 660px;
  min-height: calc(100vh - 107px);

  ${Styles.desktop`
    padding-bottom: ${primitive.$spacing10};
  `}
`;

export const RewardsToggleSectionContainer = styled.div`
  width: 100%;
  margin: 0;
  padding: ${primitive.$spacing6} 0;
  min-height: calc(100vh - 107px);
`;
